import axios, { HttpStatusCode } from 'axios';
import { BaseErrorCodeResponse } from '@/api';

function parseError(error: unknown, httpCodeErrors: Record<number, any> = {}) {
  let message = 'Something went wrong';
  let errorCode = null;
  let pendingToken: string | null = null;

  if (axios.isAxiosError(error)) {
    if (error?.response) {
      const { status } = error.response;

      const data = error.response.data as BaseErrorCodeResponse & {
        pendingToken?: string;
      };
      if (data.errorCode) {
        errorCode = data.errorCode;
      }
      if (data.pendingToken) {
        pendingToken = data.pendingToken;
      }

      switch (status) {
        case HttpStatusCode.BadRequest: {
          message = httpCodeErrors[HttpStatusCode.BadRequest] || data.message;
          break;
        }
        case HttpStatusCode.NotFound: {
          message = httpCodeErrors[HttpStatusCode.NotFound] || data.message;
          break;
        }
        case HttpStatusCode.Unauthorized: {
          message =
            httpCodeErrors[HttpStatusCode.Unauthorized] || 'Unauthorized';
          break;
        }
        case HttpStatusCode.Forbidden: {
          message = httpCodeErrors[HttpStatusCode.Forbidden] || 'Forbidden';
          break;
        }
        case HttpStatusCode.Conflict: {
          message = httpCodeErrors[HttpStatusCode.Conflict] || data.message;
          break;
        }
        case HttpStatusCode.MethodNotAllowed: {
          message =
            httpCodeErrors[HttpStatusCode.MethodNotAllowed] || data.message;
          break;
        }
        default:
          break;
      }
    } else if (error?.code) {
      message = error.message;
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  return { message, errorCode, pendingToken };
}

export { parseError };
